import React from "react";
import { Search, FileText, Droplets, FileCheck2, ShieldCheck, RefreshCw, ArrowRight } from "lucide-react";

const flow = [
  { icon: Search, label: "TakKoll" },
  { icon: FileText, label: "Offert" },
  { icon: Droplets, label: "Behandling" },
  { icon: FileCheck2, label: "Digital takrapport" },
  { icon: ShieldCheck, label: "Garanti" },
  { icon: RefreshCw, label: "HPR Care" },
];

export default function Positioning() {
  return (
    <section className="bg-white py-14 lg:py-20 border-b border-slate-100">
      <div className="mx-auto max-w-7xl px-6">
        <div className="reveal max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.15em] text-[#1B45C4]">Så jobbar vi</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-extrabold text-slate-900">
            Komplett takunderhåll – från kontroll till långsiktig skötsel
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            HPR är inte ännu ett företag som bara tvättar tak. Vi tar ansvar för hela takets liv –
            med en tydlig process du kan följa steg för steg.
          </p>
        </div>

        <div className="reveal mt-10 flex flex-wrap items-stretch gap-3">
          {flow.map((s, i) => (
            <React.Fragment key={s.label}>
              <div className="flex flex-1 min-w-[140px] flex-col items-center gap-2 rounded-2xl bg-[#f0f7ff] px-4 py-5 text-center ring-1 ring-[#dbeafe]">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#1B45C4]/10">
                  <s.icon className="w-5 h-5 text-[#1B45C4]" />
                </div>
                <span className="text-sm font-bold text-slate-900">{s.label}</span>
              </div>
              {i < flow.length - 1 && (
                <ArrowRight className="hidden self-center w-5 h-5 shrink-0 text-[#38BDF8] lg:block" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
